/* eslint import/no-cycle: 0 */

import Container from './Provider-container';

import Context from '../context';

export interface ViewComponentProps {
  /**
   * Children
   */
  children?: JSX.Element[] | JSX.Element;
  /**
   * Name of field
   */
  item?: {
    title?: string;
    description?: string;
    quantity?: number;
    price?: {
      amount?: number;
    };
    vat?: {
      amount?: number;
    };
    vat_rate?: string;
    style?: string;
    quote_document?: string;
  };
  /**
   * Is loading
   */
  isLoading?: boolean;
  /**
   * Total price props
   */
  totalPriceProps?: object;
  variant?: string;
}

const ViewComponent = ({ children, ...restProps }: ViewComponentProps) => (
  <Container {...restProps}>
    {(values) => <Context.Provider value={values}>{children}</Context.Provider>}
  </Container>
);

ViewComponent.defaultProps = {
  children: null,
  isLoading: undefined,
  item: undefined,
  totalPriceProps: {},
};

ViewComponent.displayName = 'LineItem-Context-Provider-view';

export default ViewComponent;
